// extracted by mini-css-extract-plugin
export default {"scrollbarY":"Scrollbar_scrollbarY__CkD3x"};